var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button gray circle",class:{ 'red': _vm.value },on:{"click":_vm.toggle}},[(_vm.value)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['fas', 'heart']}}):_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['far', 'heart']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }